import React from "react";

import { observer } from "mobx-react";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { BetBuilderPicksOfferTips } from "./BetBuilderPicksOfferTips";
import BetBuilderPicksQuotaButton from "./BetBuilderPicksQuotaButton";

import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";

export default observer(function BetBuilderPicksEventCard(props: {
	BBPick: BetBuilderPick;
	maxOffers?: number;
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();

	const isFaded =
		props.maxOffers && props.BBPick.multiOffers.length > props.maxOffers;

	if (!store.betBoosterEventPicks.betBuilderPicksStore) {
		return null;
	}

	return (
		<>
			<div className="card--qp__offer card--bbp__offer">
				<BetBuilderPicksOfferTips
					multiOffers={props.BBPick.multiOffers}
					maxOffers={props.maxOffers}
				/>
				{isFaded && <div className="card--qp__more card--bbp__more" />}
			</div>

			<BetBuilderPicksQuotaButton
				BBPick={props.BBPick}
				store={store.betBoosterEventPicks.betBuilderPicksStore}
			/>
		</>
	);
});
